export default {
	edit: 'Edit',
	delete: 'Delete',
	enable: 'Enable for this scenario',
	disable: 'Disable for this scenario',
	next_step: 'Next step',
	skip: 'Skip',
	finish_review: 'Finish review',
	skip_review: 'Skip the review',
	view: 'View details',
	close: 'Close',
	cancel: 'Cancel',
	confirm: 'Yes',
	send: 'Send',
	clone: 'Clone',
	open: 'Open',
	sign_out: 'Sign out',
	search: 'Search',
	save: 'Save',
	sort_by_name: 'Sort by name (A→Z)',
	sort_by_importance: 'Sort by importance (high→low)',
	filter_positive: 'Filter positive stakeholders',
	filter_negative: 'Filter negative stakeholders',
	export: {
		excel: 'Export as Excel file',
		image: 'Export visualization as image'
	},
	click_to_select: 'Click to select',
	click_to_drag: 'Drag&drop to move',
	confirm_drop: {
		message_baseline:
			'You are updating the baseline, do you confirm the changes?',
		message_scenario:
			'You are updating scenario {{scenarioName}}, do you confirm the changes?',
		likelihood: 'Likelihood',
		impact: 'Impact',
		before: 'Before',
		after: 'After'
	}
};
